import React,{useState,useEffect,useRef}from 'react'
import { Modal,message,Form,Input, } from 'antd';
import {useBnsGuiGeUpdateQuery, useBnsGuiGeUpdateSaveMutation } from '../../store/BnsKeJiApi';
import UploadOne from '../../cpn/UploadOne';
import ModuleSelect from '../../backend/module/ModuleSelect';
function SpecEdit(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        bsg_content:''
    }); 
    const {data,isSuccess} = useBnsGuiGeUpdateQuery({bsg_id:props.bsg_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    bsg_name:data.Result.bsg_name,
                    bsg_image:[data.Result.bsg_image],
                    bsg_price:data.Result.bsg_price,
                    bsg_bg_id:[data.Result.bsg_bg_id],
                    bsg_bgn_id:[data.Result.bsg_bgn_name],
                })
                setInfo(prevState=>({...prevState,
                    bsg_name:data.Result.bsg_name,                  
                    bsg_bgn_id:data.Result.bsg_bgn_id,
                    bsg_bgn_name:data.Result.bsg_bgn_name,
                    bsg_image:data.Result.bsg_image,
                    bsg_bg_id:data.Result.bsg_bg_id,                  
                    bsg_bg_name:data.Result.bsg_bg_name,                  
                    bsg_price:data.Result.bsg_price,                  
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useBnsGuiGeUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}>修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改版本'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit({
                        "bsg_bg_id" : info.bsg_bg_id,
                        "bsg_bg_name" : info.bsg_bg_name,
                        "bsg_bgn_id" : info.bsg_bgn_id,
                        "bsg_bgn_name" : info.bsg_bgn_name,
                        "bsg_cid" : localStorage.getItem('eu_id'),
                        "bsg_cname" : localStorage.getItem('eu_name'),
                        "bsg_name" : info.bsg_name,
                        "bsg_price" : info.bsg_price,
                        "bsg_image" : info.bsg_image,     
                        "bsg_id" : props.bsg_id,                     
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                   <ModuleSelect
                        nameProduct='bsg_bg_id'
                        nameVersion='bsg_bgn_id'
                        label='版本'
                        required
                        onChangeProduct={(e,f) => {
                            setInfo(prevState=>({
                                ...prevState,
                                bsg_bg_id:e,
                                bsg_bg_name:f.label
                            }))
                        }}
                        onChangeVersion={(e,f) => {
                            setInfo(prevState=>({
                                ...prevState,
                                bsg_bgn_id:e,
                                bsg_bgn_name:f.label
                            }))
                        }}
                    />
                    <Form.Item 
                        name="bsg_name" 
                        label='名称' 
                        wrapperCol={{span:10}} 
                        required

                    >
                        <Input
                             onChange={(e) => {setInfo(prevState=>({...prevState,bsg_name:e.target.value}))}}
                        />
                    </Form.Item>                     
                    <UploadOne
                        name="bsg_image" 
                        label='图标' 
                        wrapperCol={{span:20}} 
                        fileStr={(e) => {
                            setInfo(prevState=>({...prevState,bsg_image:e}))
                        }}
                    />
                    <Form.Item 
                        name="bsg_price" 
                        label='价格' 
                        wrapperCol={{span:10}} 
                    >
                        <Input
                             onChange={(e) => {setInfo(prevState=>({...prevState,bsg_price:e.target.value}))}}
                        />
                    </Form.Item> 
                </Form>
            </Modal>
        </>
    )
}

export default SpecEdit